import { Modal as ReactModal } from "@certn/cascadia-react/components/modal/Modal";
import { memo } from "react";

import { CascadiaModalProps } from "./types";

export const Modal = memo(function (props: CascadiaModalProps) {
  return <ReactModal {...props} />;
});
